import {
    defineStore
} from 'pinia'

export const useStore = defineStore('userStore', {
    state: () => {
        return {
            info: {},
            roles: [],
            featureKeys: []
        }
    }
})